import flatten from 'flat';
import polishMessages from './pl.json';

export default flatten(polishMessages) as Record<string, string>;